module.exports = __webpack_public_path__ + "static/media/icon-price-low.52504f71.svg";